"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingIndicator = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const box_1 = require("./box");
exports.LoadingIndicator = (0, styled_components_1.default)(box_1.LoadingIndicatorBox) `
  width: 180px;
  height: 60px;

  span {
    display: block;
    font-size: 11px;
  }

  div {
    margin-top: 5px;
  }
`;
//# sourceMappingURL=loading-indicator.js.map